<template>
  <b-container fluid>
    <backlink />
    <h1>Demandes de retour</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="material_retrieving_place" slot-scope="{ data }">
        <b-badge variant="primary"></b-badge>
        <span v-if="data.value.value == 'chronopost'" class="badge badge-rounded badge-chronopost" v-b-tooltip.hover
              title="Retour Chronopost"><i class="fa fa-truck-moving"></i></span>
        <span v-if="data.value.value == 'agency'" class="badge badge-rounded badge-agency" v-b-tooltip.hover
          title="Retour depuis une agence"><i class="fa fa-truck"></i></span>
        <span v-if="data.value.value == 'project'" class="badge badge-rounded badge-project" v-b-tooltip.hover
          title="Retour depuis un chantier"><i class="fa fa-truck"></i></span>
        <span v-if="data.value.value == 'other'" class="badge badge-rounded badge-other" v-b-tooltip.hover
          title="Autre retour"><i class="fa fa-truck"></i></span>
        <span v-if="data.value.value == 'axiloc'" class="badge badge-rounded badge-axiloc" v-b-tooltip.hover
          title="Dépôt direct à l'entrepôt ESM"><i class="fa fa-truck"></i></span>
      </template>
      <template slot="exchange" slot-scope="{ data }">
        <b-badge v-if="data.value == 'Échange'" variant="info">Échange</b-badge>
        <template v-else>{{ data.value }}</template>
      </template>
      <template slot="status" slot-scope="{ data }">
        <b-badge variant="primary">{{ data.value }}</b-badge>
      </template>
      <template slot="unique_references" slot-scope="{ data }">
        <template v-if="data.value">
          {{ data.value.first }}
          <b-badge
            v-if="data.value.others.length"
            variant="secondary"
            class="ml-1"
            v-b-tooltip.hover
            :title="referencesTooltip(data.value.others)"
            >+{{ data.value.others.length }}</b-badge
          >
        </template>
        <template v-else>-</template>
      </template>
      <template slot="group_slugs" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge v-if="data.value.includes('outillage')" variant="outillage" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('instruments')" variant="instruments" class="circle float-left"
            v-b-tooltip.hover :title="$store.getters['renting_preparation/getGroup']('instruments').text">
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge v-else variant="transparent" class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text">
            &nbsp;
          </b-badge>
          <b-badge v-if="data.value.includes('service_et_logistique')" variant="service_et_logistique"
            class="circle float-left" v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text">
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

const BUSINESS_RETURN_STATUS_TABS = [
  "business-return-en-attente",
  "business-return-en-attente-d-informations-complementaires",
  "business-return-transport-en-cours",
  "business-return-receptionnee",
  "business-return-annule",
];

export default {
  name: "BusinessReturnList",
  components: {
    AdminTable,
  },
  data() {
    return {};
  },
  computed: {
    // INC-001 : true si l'utilisateur n'a pas d'entrepôt rattaché (accès à tous les entrepôts)
    isAllWarehouses: function () {
      return !this.$store.getters["auth/warehouse"];
    },
    // INC-001 : on retire le filtre entrepôt pour les utilisateurs rattachés à un
    // entrepôt (périmètre déjà forcé côté serveur)
    config: function () {
      if (this.isAllWarehouses) {
        return config;
      }
      return { ...config, fields: config.fields.filter((field) => field.name !== "warehouse") };
    },
    options: function () {
      let status_options = this.$store.getters["status/getByGroup"]("business-return").selectOptions(
        "status_slug",
        "name"
      )
      return {
        // Onglets désignés par slug, dans l'ordre du workflow : l'API trie par libellé, et un
        // index positionnel se décale dès qu'un statut s'ajoute au groupe (« Annulé »).
        status_options: BUSINESS_RETURN_STATUS_TABS.map((slug) =>
          status_options.find((option) => option.value === slug)
        ).filter(Boolean),
        group_slugs_options: this.$store.getters["renting_preparation/getGroups"],
        // Échanges (SFD Échanges et stockage 1.1) : suffixe -E, badge « Échange ».
        type_options: [
          { value: null, text: "Tous" },
          { value: 'standard', text: "Standard" },
          { value: 'exchange', text: "Échange" },
        ],
        // INC-003 : options du filtre entrepôt ("-- Tout --" ajouté par AdminTableSync)
        warehouse_options: (this.$store.getters["warehouse/getAll"] || []).map((w) => ({ value: w.id, text: w.internal_code + " - " + w.name })),
      };
    },
  },
  mounted() {
    // INC-001 : entrepôts pour le filtre (seulement utile en accès-tout)
    if (this.isAllWarehouses) {
      this.$store.dispatch("warehouse/getAll");
    }
  },
  methods: {
    /**
     * Contenu de l'infobulle des références non affichées : une par ligne, à puces.
     * Le retour à la ligne est rendu par `white-space: pre-line` sur `.tooltip-inner`,
     * ce qui évite d'injecter du HTML dans une infobulle.
     *
     * @param   {string[]}  references  Libellés des références restantes
     * @returns {string}                Liste à puces, une par ligne
     */
    referencesTooltip(references) {
      return references.map((reference) => "• " + reference).join("\n");
    },

    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "businessreturn", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              status_slug: ctx.extended_filters_model.status,
              startWithdrawWishedDate: ctx.extended_filters_model.withdraw_wished_date.start
                ? self
                    .$moment(ctx.extended_filters_model.withdraw_wished_date.start)
                    .format("YYYY-MM-DD")
                : null,
              endWithdrawWishedDate: ctx.extended_filters_model.withdraw_wished_date.end
                ? self
                    .$moment(ctx.extended_filters_model.withdraw_wished_date.end)
                    .format("YYYY-MM-DD")
                : null,
              group_slug: ctx.extended_filters_model.group_slugs,
              // INC-003 : filtre entrepôt de retour (ignoré côté serveur si l'user est scopé)
              warehouse: ctx.extended_filters_model.warehouse,
              type: ctx.extended_filters_model.type,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.businessReturns || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";

.badge {
  &.badge-rounded {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.badge-chronopost {
    background-color: $yellow;
    color: #ffffff;
  }

  &.badge-axiloc {
    background-color: $primary;
    color: #ffffff;
  }

  &.badge-agency {
    background-color: $blue;
    color: #ffffff;
  }

  &.badge-project {
    background-color: $orange;
    color: #ffffff;
  }

  &.badge-other {
    background-color: $purple;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BusinessReturn/BusinessReturnList.vue